module.exports = __webpack_public_path__ + "assets/img/yzk.eba0bbb9.png";